var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-cell"},_vm._l((_vm.baseInfo),function(item,index){return _c('div',{key:index,staticClass:"company-cell-item"},[_c('div',{staticClass:"num"},[_vm._v(_vm._s(item.num))]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/practice/company-code-cell/index.vue?vue&type=template&id=3c442597&scoped=true
// module id = null
// module chunks = 